import { render, staticRenderFns } from "./ModalUploadMedia.vue?vue&type=template&id=ddcb961e&scoped=true&"
import script from "./ModalUploadMedia.vue?vue&type=script&lang=js&"
export * from "./ModalUploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploadMedia.vue?vue&type=style&index=0&id=ddcb961e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcb961e",
  null
  
)

export default component.exports